import { createGlobalStyle } from "styled-components";
import { DatePicker } from "antd";
import styled from "styled-components";

export const StyledDatePicker = styled(DatePicker)`
  && {
    .ant-picker-input {
      display: none !important;
    }
    .ant-picker-outlined {
      display: none !important;
    }
  }
`;
export const CalendarWrapper = styled.div`
  display: flex;
`;

export const CalendarFooterWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const CalendarComponent = styled.div`
  position: relative;
`;

export const NotificationCalendarStyle = createGlobalStyle`
  .ant-picker-dropdown {
   position: static !important;
    inset: unset !important;
    transform: unset !important;
    box-shadow: none;
    margin: 0;
    width: fit-content;
    .ant-picker-panel-container {
      box-shadow: none;
      .ant-picker-panel-layout {
        .ant-picker-panel {
         .ant-picker-cell {
         .ant-picker-cell-inner {
            height: 30px;
            width: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
         }
            
          /* ===== In-Range Highlight Style ===== */
            .ant-picker-cell-inner.in-range {
              width: 100%;
              background-color: #DAE6F7;
              color: black;
              border-radius: 0; /* No rounding for middle cells */
            }
            .ant-picker-cell-inner.range-start {
             background-color: #0C53BB!important;
              color: white;
              border-radius: 4px;
            }
            .ant-picker-cell-inner.range-end {
             background-color: #0C53BB!important;
              color: white;
              border-radius: 4px;
            }
          }

         /* ===== Selected Cell Style ===== */
          .ant-picker-cell.ant-picker-cell-selected {
            .ant-picker-cell-inner {
              background-color: #0C53BB;
              color: white;
              border-radius: 4px;
            }
          }

          .ant-picker-cell.ant-picker-cell-today {
            .ant-picker-cell-inner::before {
              border-radius: 4px;
              border-color: transparent;
            }
          }

          /* ===== Header Style ===== */
          .ant-picker-header {
            border-bottom: none;
            .ant-picker-header-view {
              color: #1B2028;
              font-family: "Manrope", sans-serif;
              font-weight: 500;
              font-size: 14px;
            }
          }

          /* ===== Body Styles ===== */
          .ant-picker-body {
            border: 1px solid #f3f4f7;
            .ant-picker-content {
              thead tr th {
                color: #5A6C87;
                font-family: "Manrope", sans-serif;
                font-weight: 500;
                font-size: 14px;
              }
            }

            /* Disabled Cell Styles */
            .ant-picker-cell.ant-picker-cell-disabled {
              color: lightgray;
              background: none;
            }

            .ant-picker-cell.ant-picker-cell-disabled::before {
              color: gray;
              background: none;
            }
          }
        }
            
        }
        .ant-picker-footer {
          display: none;
        }
      }
    }
  }
`;

export const ApplyButton = styled.button`
  background-color: #0c53bb;
  color: #fff;
  text-transform: none;
  padding: 6px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0px;
  flex-shrink: 0;
  width: fit-content;
  height: 32px;
  font-weight: 600;
  font-family: "Manrope", sans-serif;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #0a4296;
  }

  &:disabled {
    opacity: 0.4;
    background-color: #0c53bb;
    color: #fff;
    cursor: not-allowed;
  }
`;

export const ResetButton = styled(ApplyButton)`
  background-color: #f3f4f7;
  color: #1b2028;

  &:hover {
    background-color: #f3f4f7;
  }
`;
